import { FixedSizeList as List } from 'react-window';
import { GQLBasicItem } from 'townapps-models/graphql/types';
import AutoSizer from 'react-virtualized-auto-sizer';
import Card from '../card';
import styled from 'styled-components';
import { useEffect, useRef, useState } from 'react';
import Link from 'next/link';
import { useRouter } from 'next/router';
import firebase from '../../utils/firebase';
import translateType from '../../utils/translateType';

type Props = {
  item?: GQLBasicItem[];
};

const Container = styled.div<{ small?: boolean }>`
  flex: 1;
  min-height: ${p => (p.small ? 252 : 352)}px;
  height: 100%;
`;

const CardsContainer = styled.div`
  padding: 156px 16px 16px;
  margin-bottom: 16px;
  width: 220px;
  display: flex;
  height: 100%;
  align-items: center;
  justify-content: center;
`;

const CardsNormal: React.FC<Props> = ({ item }) => {
  const router = useRouter();
  const [total, setTotal] = useState<2 | 3>(2);
  const infiniteScrollRef = useRef(null);

  const { slug } = router.query;
  const trackView = (item: GQLBasicItem) => {
    firebase.client.analytics().logEvent('select_item', {
      item_list_name: `${slug} listings`,
      items: [{ item_id: item.id, item_name: item.title, item_variant: item.type }],
    });
  };
  const heightCard = 470 + 24;

  useEffect(() => {
    infiniteScrollRef?.current?.scrollTo(0);
  }, [item]);

  useEffect(() => {
    setTotal(window?.outerWidth <= 1680 ? 2 : 3);
    window.addEventListener('resize', () => {
      setTotal(window?.outerWidth <= 1680 ? 2 : 3);
    });
  }, []);

  const renderCard = ({ data, index, style }: { index: number; style: any; data: GQLBasicItem[] }) => {
    const first = data[index * total];
    const second = data[index * total + 1];
    const third = data[index * total + 2];

    const cards = [];
    switch (total) {
      case 3:
        if (third) {
          cards.push(
            <Link href={`/${slug}/${translateType(third.__typename)}/${third.slug}`} passHref>
              <Card
                onClick={() => trackView(third)}
                category={translateType(third.__typename)}
                key={third.id}
                image={third.image}
                title={third.title}
                description={third.description}
                style={{ width: 200, height: 470, marginRight: 24 }}
              />
            </Link>,
          );
        }
      case 2:
        if (second) {
          cards.push(
            <Link href={`/${slug}/${translateType(second.__typename)}/${second.slug}`} passHref>
              <Card
                onClick={() => trackView(second)}
                category={translateType(second.__typename)}
                key={second.id}
                image={second.image}
                title={second.title}
                description={second.description}
                style={{ width: total === 3 ? 200 : 186, height: 470, marginRight: 24 }}
              />
            </Link>,
          );
        }
    }

    cards.push(
      <Link href={`/${slug}/${translateType(first.__typename)}/${first.slug}`} passHref>
        <Card
          onClick={() => trackView(first)}
          category={translateType(first.__typename)}
          key={first.id}
          image={first.image}
          title={first.title}
          description={first.description}
          style={{ width: total === 3 ? 200 : 186, height: 470 }}
        />
      </Link>,
    );
    return (
      <>
        <CardsContainer style={{ ...style }}>{cards}</CardsContainer>
      </>
    );
  };

  return (
    <Container>
      <AutoSizer>
        {({ height, width }) => (
          <>
            <List
              width={width}
              height={height}
              overscanCount={45}
              itemCount={Math.ceil(item.length / total)}
              itemSize={heightCard}
              ref={infiniteScrollRef}
              itemData={item}>
              {renderCard}
            </List>
          </>
        )}
      </AutoSizer>
    </Container>
  );
};

export default CardsNormal;
